/**
 * Where files from public/ actually live.
 *
 * This bundle does not run on its own domain. It is embedded into pages served
 * from CUSTOMER domains (lpyk6a.flexifunnels.com, …) which include only the
 * JS/CSS tags, pointing at the app's own origin:
 *
 *     <script src="https://courses.flexi-funnels.com/static/js/main.js">
 *
 * Webpack-emitted assets carry that origin, but a hand-written root-relative
 * path does not: `/images/course-default.svg` resolves against the CUSTOMER's
 * site, which answers 405 (it has no such route) — never against ours. Same for
 * /favicon.ico and /manifest.json.
 *
 * PUBLIC_URL is the supported way to set this (see craco.config.js), so it wins
 * when the build defines one. When it doesn't — which is the case for the
 * Cloudflare Pages build serving courses.flexi-funnels.com today — fall back to
 * the origin the bundle itself was loaded from, read off its own <script> tag.
 * That keeps public/ assets working without waiting on a build-env change, and
 * costs nothing once PUBLIC_URL is set properly.
 */

function detectBase() {
  const fromEnv = (process.env.PUBLIC_URL || "").trim();
  if (fromEnv) return fromEnv.replace(/\/+$/, "");

  if (typeof document === "undefined") return "";

  // While this module is evaluated we are still inside the synchronous run of
  // the bundle's own <script>, so currentScript points at it. The querySelector
  // fallbacks cover async/deferred loading, where currentScript is null.
  const el =
    document.currentScript ||
    document.querySelector('script[src*="/static/js/main"]') ||
    Array.from(document.querySelectorAll("script[src]")).find((s) => /\/static\/js\//.test(s.src));

  // .src is always absolute, so a same-origin bundle yields the page's own
  // origin. Return "" for that case and keep paths root-relative — there is
  // nothing to correct, and dev/test URLs stay readable.
  const src = el && el.src;
  if (!src) return "";
  const cut = src.indexOf("/static/js/");
  if (cut <= 0) return "";
  const base = src.slice(0, cut);
  return base === window.location.origin ? "" : base;
}

/** Origin (no trailing slash) that public/ files are served from. May be "". */
export const ASSET_BASE = detectBase();

/** asset("/images/x.svg") -> a URL that resolves on OUR origin, not the customer's. */
export function asset(path) {
  if (!path) return ASSET_BASE;
  return `${ASSET_BASE}${path.startsWith("/") ? "" : "/"}${path}`;
}
